export let basePath = 'http://localhost:3977/api';
export const apiVersion = 'v1';

if (process.env.NODE_ENV === 'production') {
  basePath = 'https://viarco-dot-bs-proyecto1.rj.r.appspot.com/api';
} else {
  console.log('Desarrollo..');
}
